import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Loader } from 'components/index.ts';
import OfferTable from 'components/OfferTable/OfferTable';
import Slider from 'components/Slider/Slider';
import styles from 'components/CalculatorBestOffer/CalculatorBestOffer.module.scss';
import { ClientOffer } from 'hooks/webapi/client/useClientOfferQuery';

export type Constraints = {
  min: number;
  max: number;
  step: number;
};

export type Props = {
  onAmountChange: (value: number) => void;
  constraints?: Constraints;
  offer?: ClientOffer;
  loading?: boolean;
  calculatorAmount?: number;
  sliderDisabled?: boolean;
};

const CalculatorBestOffer = memo(function Calculator({
  onAmountChange,
  constraints,
  offer,
  loading,
  calculatorAmount,
  sliderDisabled = false,
}: Props) {
  const { t } = useTranslation();

  return (
    <div
      className={styles['calculator-wrapper']}
      data-test="calculatorBestOffer-layout"
    >
      <div className={styles['desktop-slider-wrapper']}>
        {constraints ? (
          <Slider
            dataTest="calculatorBestOffer-slider"
            min={constraints.min}
            max={constraints.max}
            step={constraints.step}
            value={
              calculatorAmount !== undefined
                ? calculatorAmount
                : constraints.max
            }
            onAfterChange={onAmountChange}
            units={t('calculator:amount_units')}
            heading={t('calculator:term_slider_title')}
            headingStyle="pb-0"
            disabled={sliderDisabled}
          />
        ) : (
          <Loader />
        )}
      </div>
      <hr className={styles['hr-calculator']} />
      <div className={styles['offer-wrapper']}>
        <OfferTable
          totalPrincipal={offer?.totalPrincipal || 0}
          totalRepayableAmount={offer?.totalRepayableAmount || 0}
          extensionFees={offer?.extensionFees[30] || 0}
          interestRate={offer?.interestRate}
          assignedInterest={offer?.assignedInterest}
          firstPaymentDate={offer?.firstPaymentDate}
          loading={loading}
          futureExtensionFees={offer?.futureExtensionFees?.[0]?.fee}
        />
      </div>
    </div>
  );
});

export default CalculatorBestOffer;
